import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Stack } from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";
import CclButton from "./cclButtons/cclButton";

export type CclErrorDialogProps = {
    open: boolean;
    title?: string | undefined;
    msg?: string | undefined;
    onOk: () => void;
};

const CclErrorDialog: React.FC<CclErrorDialogProps> = (props) => {
    const defaultTitle: string = "Error";
    const defaultMsg: string = "There was an error with the previous operation.";
    const [title, setTitle] = React.useState<string>(defaultTitle);
    const [message, setMessage] = React.useState<string>(defaultMsg);

    React.useEffect(() => {
        if (props.title == null || props.title === "") {
            setTitle(defaultTitle);
        } else {
            setTitle(props.title);
        }
    }, [props.title]);

    React.useEffect(() => {
        if (props.msg == null || props.msg === "") {
            setMessage(defaultMsg);
        } else {
            setMessage(props.msg);
        }
    }, [props.msg]);

    const handleClose = (evt: any) => {
        if (props.onOk) {
            props.onOk();
        }
    };

    return (
        <Dialog
            open={props.open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
            <DialogContent>
                <Stack direction="row" alignItems={"center"}>
                    <ErrorIcon color="error" fontSize="large" sx={{ pr: 1 }} />
                    <DialogContentText id="alert-dialog-description">
                        <span>{message}</span>
                    </DialogContentText>
                </Stack>
            </DialogContent>

            <DialogActions>
                <CclButton id="ok-btn" onClick={handleClose} mode={"primary"}>
                    Ok
                </CclButton>
            </DialogActions>
        </Dialog>
    );
};

export default CclErrorDialog;
